module.exports = __webpack_public_path__ + "static/brasil_junior_dark-3f418af23f247b2b2afa46500f97d052.svg";